import { DataGrid } from '@material-ui/data-grid';
import { find, forEach } from 'lodash';
import React, { useEffect, useState, useContext, useMemo } from 'react';
import AppContext from '../../../App/AppContext';
import { PrimaryButton } from '../../../Core/FormInput';
import { assignedTechAndList, assignedTechnicianToJob } from '../../../Core/Service/workflowData-service';
import { Checkbox, Grid } from '@material-ui/core';
import './assign-technician.scss';
import { AppStorage } from '../../../Core/Service/storage-service';

const AssignTech = (props) => {
    const { hideTopNavAndMenu, showToast } = useContext(AppContext);
    const getClass = (params) => {
        if (params.row.isAssigned) {
            return 'is-assigned';
        } else if (params.row.selectedNext) {
            return 'will-be-assigned';
        }
    };

    let isAssignTechnicianAllowed = AppStorage.getCanAssignTechnicianAllowed();

    const defaultColumns = [
        { field: 'name', headerName: 'Name', flex: 1 },
        { field: 'jobAssigned', headerName: 'Jobs Assigned ', width: 160 },
        {
            field: 'isAssigned',
            headerName: 'Assign',
            width: 105
        }
    ].map((c) => ({ ...c, cellClassName: getClass }));

    const [state, setState] = useState({
        technicians: [],
        isEnable: false
    });

    const onCheckboxClick = (id) => (e) => {
        const { checked } = e.target;
        if (isAssignTechnicianAllowed) {
            setState((st) => {
                let newSt = { ...st };
                const rw = find(newSt.technicians, (t) => t.id === id);
                if (rw) {
                    rw.selectedNext = checked; //!rw.selectedNext;
                    rw.isAssigned = checked; // !rw.isAssigned;
                    rw.mode = checked ? 'A' : 'D';
                }
                newSt.technicians = [...newSt.technicians];
                newSt.isEnable = true;
                return newSt;
            });
        }
    };

    const columns = () => {
        let allCols = [...defaultColumns];
        let col = allCols.find((c) => c.field === 'isAssigned');
        col.renderCell = (params) => (
            <>
                <Checkbox onClick={onCheckboxClick(params.row.id)} defaultChecked={params.value} disabled={!isAssignTechnicianAllowed} />
                {/* <input type="checkbox"  defaultChecked={params.value} onChange={onCheckboxClick(params.row.id)} /> */}
            </>
        );
        return allCols;
    };

    const getAssignedTechAndOthers = async () => {
        const res = await assignedTechAndList(props.jobId);
        if (res.success) {
            setState((st) => ({ ...st, technicians: res.data }));
        } else {
            showToast(res.message);
        }
    };

    useEffect(() => {
        getAssignedTechAndOthers();
    }, [props.jobId]);

    const saveTechnicianAndMove = async () => {
        const techToSave = state.technicians.filter((c) => c.mode);
        const res = await assignedTechnicianToJob(props.jobId, techToSave);
        if (res.success) {
            showToast(res.message);
            props.handleCancel(true);
        }
        if (!res.success) {
            console.error(res);
        }
    };

    return (
        <Grid container>
            <Grid item xs={12} style={{ height: 'calc(100vh - 300px)' }}>
                <DataGrid
                    rows={state.technicians}
                    headerHeight={30}
                    rowHeight={30}
                    hideFooter={true}
                    columns={columns()}
                    pageSize={100}
                    disableColumnMenu={true}
                    showColumnRightBorder={true}
                />
            </Grid>
            <Grid item xs={12}>
                <PrimaryButton fullWidth className="mt-20" onClick={saveTechnicianAndMove} disabled={!state.isEnable}>
                    Assign Technician
                </PrimaryButton>
            </Grid>
        </Grid>
    );
};

export default AssignTech;
